import type React from 'react';

import { Spinner } from '@change/ds-core-ui';

import { useSignaturesDistributionContext } from '../../shared/provider';

export const Loaders: React.FC = () => {
	const {
		data: { isLoadingData, isCrunchingData },
	} = useSignaturesDistributionContext();

	return (
		<>
			{isLoadingData && <Spinner data-testid="loading-data" className="mx-auto my-64" />}
			{isCrunchingData && <Spinner data-testid="crunching-data" className="mx-auto my-64" />}
		</>
	);
};
